module.exports = __webpack_public_path__ + "static/header-image-1e41c737efab4f05e1e81b69f550a4c5.jpg";